import { RetryLink } from '@apollo/client/link/retry';

const MAX_ATTEMPTS = 3;

export const apolloRetryLink = new RetryLink({
  attempts: (count, operation, error) => {
    const { shouldRetry } = operation.getContext();
    if (!shouldRetry) return false;

    const statusCode = error.statusCode ?? error.networkError?.statusCode;
    const isNetworkError = Boolean(error.networkError) || (statusCode >= 500 && statusCode < 600);

    const lessThanMaxAttempts = count < MAX_ATTEMPTS;
    return isNetworkError && lessThanMaxAttempts;
  },
  delay: { initial: 300, jitter: true, max: 2000 },
});
